<div class="table-responsive animated fadeIn slow">
    <div>
        <h2 style="text-align: center;" class="titulo">LISTADO DE PLANTELES</h2>
        <!-- <h2 style="text-align: center;" class="titulo">INFORMACIÓN DEL PLANTEL</h2> -->
    </div>

    <div class="table-wrapper">
        <table datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger" class="tabla-asignaturas">
            <thead>
                <tr>
                    <th scope="row">Número de plantel</th>
                    <th scope="row">Nombre del plantel</th>
                    <th scope="row">Dirección</th>
                    <th scope="row">Teléfono del plantel</th>
                    <th scope="row">Director(a) del plantel</th>
                    <th scope="row">Teléfono del director(a)</th>
                    <th *ngIf="permisosplantel" scope="row">Editar</th>
                    <th scope="row">Ver</th>
                    <th scope="row">Ver Maps</th>
                </tr>
            </thead>
            <tbody>
                <ng-container *ngFor="let plantel of planteles">
                    <tr>
                        <td style="text-align: center;">{{plantel.idplantel}}</td>
                        <td style="text-align: left;">{{plantel.nombreplantel}}</td>
                        <td style="text-align: left;">{{plantel.direccion}}</td>
                        <td style="text-align: left;">{{plantel.telefono}}</td>
                        <td style="text-align: left;">{{plantel.ndirector}}</td>
                        <td style="text-align: left;">{{plantel.telefonodirector}}</td>
                        <td *ngIf="permisosplantel">
                            <button class="btn-icon editar" data-toggle="modal" data-target="#EditarPlantel" data-backdrop="static" (click)=" plantelinf(plantel.idplantel)"><i class="fas fa-edit"></i></button>
                        </td>

                        <td>
                            <button class="btn-icon ver" data-toggle="modal" data-target="#VerPlantel" data-backdrop="static" (click)=" plantelinf(plantel.idplantel)"> <i class="fas fa-eye"></i>
             </button>
                        </td>
                        <td>
                            <button class="btn-icon editar" data-toggle="modal" data-target="#VerMapsModal" (click)="mostrarMapaPlantel(plantel.maps)">
              <i class="fas fa-map-marked-alt"></i>
                        </button></td>
                    </tr>
                </ng-container>
            </tbody>
        </table>
    </div>
</div>
<!-- /////////////////////////////////////////////modal maps////////////////////////////////////////// -->
<div class="modal fade" id="VerMapsModal" tabindex="-1" role="dialog" aria-labelledby="VerMapsLabel" aria-hidden="true">
    <div class="modal-dialog modal-xl" role="document">
        <div class="modal-content modal-asig">
            <div class="modal-header-asig">
                <h2 class="modal-title-asig">UBICACIÓN EN GOOGLE MAPS</h2>
            </div>
            <div class="modal-body-maps">
                <div *ngIf="urlMapa; else sinMapa">
                    <iframe [src]="urlMapa" width="100%" height="500" style="border:0;" allowfullscreen="" loading="lazy">
                </iframe>
                </div>
                <ng-template #sinMapa>
                    <p class="text-center text-danger">No se encontró el enlace de ubicación para este plantel.</p>
                </ng-template>

            </div>
            <div class="modal-footer-asig">
                <button type="button" class="btn-cancelar" data-dismiss="modal">Cerrar</button>
            </div>
        </div>
    </div>
</div>
<!-- /////////////////////////////////////////MODAL VER PLANTEL/////////////////////////////////// -->
<div class="modal fade bd-example-modal-lg" id="VerPlantel" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-lg" role="dialog">
        <div class="modal-content modal-asig">
            <div class="modal-header-asig">
                <h2 class="modal-title-asig">INFORMACIÓN PLANTEL</h2>
            </div>

            <!--información-->
            <div class="modal-body-asig">
                <!--DATOS-->
                <div class="container-asig">
                    <div class="row justify-content-md-center">
                        <div class="col col-lg-5">
                            <label class="label-asig">Clave:</label>
                            <input type="text" class="form-control-asig disabled-asig" [(ngModel)]="planteless.claveplantel" required disabled>
                        </div>

                        <div class="col col-lg-5">
                            <label class="label-asig">Nombre plantel:</label>
                            <input type="text" class="form-control-asig disabled-asig" [(ngModel)]="planteless.nombreplantel" required disabled>

                        </div>

                        <div class="col col-lg-2">
                            <label class="label-asig">Activo:</label>

                            <select type="text" class="form-control-asig disabled-asig" [(ngModel)]="planteless.esactivo" required disabled>
                                <option value="true"> Si</option>
                                <option value="false"> No </option>
                            </select>

                        </div>
                    </div>
                    <br>
                    <div class="row justify-content-md-center">
                        <div class="col col-lg-5">
                            <label class="label-asig">Dirección:</label>
                            <input type="text" class="form-control-asig disabled-asig" [(ngModel)]="planteless.direccion" required disabled>
                        </div>

                        <div class="col col-lg-4">
                            <label class="label-asig">Localidad:</label>
                            <input type="text" class="form-control-asig disabled-asig" [(ngModel)]="planteless.localidad" required disabled>
                        </div>
                        <div class="col col-lg-3">
                            <label class="label-asig">Municipio:</label>
                            <input type="text" class="form-control-asig disabled-asig" [(ngModel)]="planteless.municipio" required disabled>

                        </div>
                    </div>
                    <br>
                    <div class="row justify-content-md-center">
                        <div class="col col-lg-7">
                            <label class="label-asig">Colonia:</label>
                            <input type="text" class="form-control-asig disabled-asig" [(ngModel)]="planteless.colonia" required disabled>

                        </div>
                        <div class="col col-lg-5">
                            <label class="label-asig">Código postal:</label>
                            <input type="text" class="form-control-asig disabled-asig" [(ngModel)]="planteless.codigopostal" required disabled>
                        </div>
                    </div>
                    <br>
                    <div class="row justify-content-md-center">

                        <div class="col col-lg-6">
                            <label class="label-asig">Nombre director:</label>
                            <input type="text" class="form-control-asig disabled-asig" [(ngModel)]="planteless.ndirector" required disabled>

                        </div>
                        <div class="col col-lg-6">
                            <label class="label-asig">Cargo:</label>
                            <select type="text" class="form-control-asig disabled-asig" [(ngModel)]="planteless.cargodirect" required disabled>
                            <option value>Seleccione...</option>   
                            <option value="Director General"> Director General </option>
                            <option value="Directora General"> Directora General </option>
                            <option value="Director"> Director del Plantel</option>
                            <option value="Directora"> Directora del Plantel</option>
                            <option value="Encargado del despacho de la Dirección"> Encargado del despacho de la Dirección </option>
                            <option value="Encargada del despacho de la Dirección"> Encargada del despacho de la Dirección </option>
                            </select>
                        </div>

                    </div>
                    <br>
                    <div class="row justify-content-md-center">
                        <div class="col col-lg-4">
                            <label class="label-asig">Correo institucional:</label>
                            <input type="text" class="form-control-asig disabled-asig" [(ngModel)]="planteless.correoinstitucional" required disabled>
                        </div>
                        <div class="col col-lg-4">
                            <label class="label-asig">Teléfono personal:</label>
                            <input type="text" class="form-control-asig disabled-asig" [(ngModel)]="planteless.telefonodirector" required disabled>
                        </div>
                        <div class="col col-lg-4">
                            <label class="label-asig">Correo personal:</label>
                            <input type="text" class="form-control-asig disabled-asig" [(ngModel)]="planteless.correopers" required disabled>
                        </div>
                    </div>
                    <br>
                    <div class="row justify-content-md-center">
                        <div class="col col-lg-7">
                            <label class="label-asig">Coordenadas (latitud, longitud):</label>
                            <input type="text" class="form-control-asig disabled-asig" [(ngModel)]="planteless.coorde" required disabled>
                        </div>
                        <div class="col col-lg-5">
                            <label class="label-asig">Teléfono plantel:</label>
                            <input type="text" class="form-control-asig disabled-asig" [(ngModel)]="planteless.telefono" required disabled>
                        </div>

                    </div>
                    <br>
                    <div class="row justify-content-md-center">
                        <div class="col col-lg-12">
                            <label class="label-asig">Link del maps:</label>
                            <textarea type="text" class="form-control-asig disabled-asig" [(ngModel)]="planteless.maps" rows="5" required disabled></textarea>

                        </div>


                    </div>


                </div>
            </div>

            <!--Fin-->
            <div class="modal-footer">
                <button type="button" class="btn-cancelar" data-dismiss="modal" (click)="resetPlantel()">Cancelar</button>
            </div>
            <br>
        </div>

    </div>
</div>
<!-- /////////////////////////////////////////MODAL EDITAR PLANTEL/////////////////////////////////// -->
<div class="modal fade bd-example-modal-lg" id="EditarPlantel" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-lg" role="dialog">
        <div class="modal-content modal-asig">
            <div class="modal-header-asig">
                <h2 class="modal-title-asig">EDITAR PLANTEL</h2>
            </div>

            <!--información-->
            <div class="modal-body-asig">
                <!--DATOS-->
                <div class="container-asig">
                    <div class="row justify-content-md-center">
                        <div class="col col-lg-5">
                            <label class="label-asig">Clave:</label>
                            <input type="text" class="form-control-asig disabled-asig" [(ngModel)]="planteless.claveplantel" required>
                        </div>

                        <div class="col col-lg-5">
                            <label class="label-asig">Nombre plantel:</label>
                            <input type="text" class="form-control-asig disabled-asig" [(ngModel)]="planteless.nombreplantel" required>

                        </div>

                        <div class="col col-lg-2">
                            <label class="label-asig">Activo:</label>

                            <select type="text" class="form-control-asig disabled-asig" [(ngModel)]="planteless.esactivo" required>
                                <option value="true"> Si</option>
                                <option value="false"> No </option>
                            </select>

                        </div>
                    </div>
                    <br>
                    <div class="row justify-content-md-center">
                        <div class="col col-lg-5">
                            <label class="label-asig">Dirección:</label>
                            <input type="text" class="form-control-asig disabled-asig" [(ngModel)]="planteless.direccion" required>
                        </div>

                        <div class="col col-lg-4">
                            <label class="label-asig">Localidad:</label>
                            <input type="text" class="form-control-asig disabled-asig" [(ngModel)]="planteless.localidad" required>
                        </div>
                        <div class="col col-lg-3">
                            <label class="label-asig">Municipio:</label>
                            <input type="text" class="form-control-asig disabled-asig" [(ngModel)]="planteless.municipio" required>

                        </div>
                    </div>
                    <br>
                    <div class="row justify-content-md-center">
                        <div class="col col-lg-7">
                            <label class="label-asig">Colonia:</label>
                            <input type="text" class="form-control-asig disabled-asig" [(ngModel)]="planteless.colonia" required>

                        </div>
                        <div class="col col-lg-5">
                            <label class="label-asig">Código postal:</label>
                            <input type="text" class="form-control-asig disabled-asig" [(ngModel)]="planteless.codigopostal" required>
                        </div>
                    </div>
                    <br>
                    <div class="row justify-content-md-center">

                        <div class="col col-lg-6">
                            <label class="label-asig">Nombre director:</label>
                            <input type="text" class="form-control-asig disabled-asig" [(ngModel)]="planteless.ndirector" required>

                        </div>
                        <div class="col col-lg-6">
                            <label class="label-asig">Cargo:</label>
                            <select type="text" class="form-control-asig disabled-asig" [(ngModel)]="planteless.cargodirect" required>
                            <option value>Seleccione...</option>   
                            <option value="Director General"> Director General </option>
                            <option value="Directora General"> Directora General </option>
                            <option value="Director"> Director del Plantel</option>
                            <option value="Directora"> Directora del Plantel</option>
                            <option value="Encargado del despacho de la Dirección"> Encargado del despacho de la Dirección </option>
                            <option value="Encargada del despacho de la Dirección"> Encargada del despacho de la Dirección </option>
                            </select>
                        </div>

                    </div>
                    <br>
                    <div class="row justify-content-md-center">
                        <div class="col col-lg-4">
                            <label class="label-asig">Correo institucional:</label>
                            <input type="text" class="form-control-asig disabled-asig" [(ngModel)]="planteless.correoinstitucional" required>
                        </div>
                        <div class="col col-lg-4">
                            <label class="label-asig">Teléfono personal:</label>
                            <input type="text" class="form-control-asig disabled-asig" [(ngModel)]="planteless.telefonodirector" required>
                        </div>
                        <div class="col col-lg-4">
                            <label class="label-asig">Correo personal:</label>
                            <input type="text" class="form-control-asig disabled-asig" [(ngModel)]="planteless.correopers" required>
                        </div>
                    </div>
                    <br>
                    <div class="row justify-content-md-center">
                        <div class="col col-lg-7">
                            <label class="label-asig">Coordenadas (latitud, longitud):</label>
                            <input type="text" class="form-control-asig disabled-asig" [(ngModel)]="planteless.coorde" required>
                        </div>
                        <div class="col col-lg-5">
                            <label class="label-asig">Teléfono plantel:</label>
                            <input type="text" class="form-control-asig disabled-asig" [(ngModel)]="planteless.telefono" required>
                        </div>

                    </div>
                    <br>
                    <div class="row justify-content-md-center">
                        <div class="col col-lg-12">
                            <label class="label-asig">Link del maps:</label>
                            <textarea type="text" class="form-control-asig disabled-asig" [(ngModel)]="planteless.maps" rows="5" required></textarea>

                        </div>


                    </div>


                </div>
            </div>
            <!--Fin-->
            <div class="modal-footer-asig">
                <button type="button" class="btn-guardar" data-dismiss="modal" (click)="editarPlantel()">Guardar</button>
                <button type="button" class="btn-cancelar" data-dismiss="modal" (click)="resetPlantel()">Cancelar</button>

            </div>
            <br>
        </div>

    </div>
</div>

<!-- /////////////////////////////////////////MODAL AGREGAR PLANTEL/////////////////////////////////// -->